import React from 'react';
import ReactDOM from 'react-dom/client';
import { App as AntdApp } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import App from './containers/App/Loadable';
import StoreProvider from './store/StoreProvider';
import NotificationBridge from './services/NotificationBridge';
import { ToastProvider } from './state/ToastContext';
import 'antd/dist/reset.css';
import '@munatech/nepali-datepicker/styles.css';
import './index.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StoreProvider>
    <AntdApp>
      <NotificationBridge />
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </AntdApp>
  </StoreProvider>,
);
